// Kleines Markdown (Überschriften, Listen, Links, Fett, Absätze) → sicheres HTML. Für die Termin-Akte in der
// CRM-Leiste und in der Mail an die Minimusiker:in. Alles wird escaped, Links nur http(s) oder /t/<id>.
export function markdownHtml(md: string, linkBase = ''): string {
  const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const inline = (s: string) =>
    esc(s)
      .replace(
        /\[([^\]]+)\]\((https?:\/\/[^)\s]+|\/t\/\d+)\)/g,
        (_, t: string, u: string) =>
          `<a href="${u.startsWith('/') ? linkBase + u : u}" target="_blank" rel="noreferrer">${t}</a>`,
      )
      .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
  const out: string[] = [];
  let list: string[] = [];
  const flush = () => {
    if (list.length) out.push('<ul>' + list.map((l) => `<li>${inline(l)}</li>`).join('') + '</ul>');
    list = [];
  };
  for (const raw of md.split('\n')) {
    const line = raw.trim();
    if (!line) {
      flush();
      continue;
    }
    const h = /^(#{1,3})\s+(.*)$/.exec(line);
    if (h) {
      flush();
      out.push(`<h2>${inline(h[2] ?? '')}</h2>`);
    } else if (/^[-*•]\s+/.test(line)) list.push(line.replace(/^[-*•]\s+/, ''));
    else {
      flush();
      out.push(`<p>${inline(line)}</p>`);
    }
  }
  flush();
  return out.join('');
}
